module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Posto_di_Blocco-BN.f2d0cac1.svg";